import { RuleObject } from 'antd/lib/form';
import TranslateText from 'components/hoc/TranslateText';
import { globalInputRegExp } from 'enums/regExp';
import React from 'react';

export const nepovoleneZnakyValidation = (rulesMessage: string) => [
    {
        required: true,
        message: <TranslateText>{rulesMessage}</TranslateText>
    },
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || globalInputRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>VALIDACE_GLOBAL_INPUT</TranslateText>);
        }
    })
];

export default nepovoleneZnakyValidation;
